import { useAppContext } from '../../contexts/AppContext';
import { useEffect, useRef, useState } from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsLinearGaugePlugin from './LinearGaugePlugin';
import { Box, Typography } from '@mui/material';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';
import ChartHelpTooltip from './ChartHelpTooltip';

noDataToDisplay(Highcharts);
highchartsLinearGaugePlugin(Highcharts);

type Props = {
  title: string;
  value: any;
};

const chart = {
  chart: {
    inverted: true,
    height: 70,
  },
  title: {
    text: '',
    style: {
      display: 'none',
    },
  },
  xAxis: {
    lineColor: '#C0C0C0',
    labels: {
      enabled: false,
    },
    tickLength: 0,
  },
  yAxis: {
    min: 0,
    max: 100,
    tickLength: 5,
    tickWidth: 1,
    tickColor: '#C0C0C0',
    gridLineColor: '#C0C0C0',
    gridLineWidth: 1,
    minorTickInterval: 5,
    minorTickWidth: 1,
    minorTickLength: 5,
    minorGridLineWidth: 0,
    title: null,
    labels: {
      format: '{value}%',
    },
    plotBands: [
      {
        // label: {
        //   text: 'Low Risk',
        //   // y: 20
        // },
        from: 0,
        to: 25,
        color: 'rgba(66,185,114,0.8)',
      },
      {
        // label: {
        //   text: 'Moderate Risk'
        // },
        from: 25,
        to: 50,
        color: 'rgba(255,185,29,0.8)',
      },
      {
        // label: {
        //   text: 'High Risk'
        // },
        from: 50,
        to: 75,
        color: 'rgba(190,106,20,0.8)',
      },
      {
        // label: {
        //   text: 'Very High Risk'
        // },
        from: 75,
        to: 100,
        color: 'rgba(177,42,46,0.8)',
      },
    ],
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  exporting: { enabled: false },
  series: [
    {
      type: 'lineargauge',
      data: [92],
      color: '#000000',
      dataLabels: {
        enabled: true,
        align: 'center',
        format: '{point.y}%',
      },
    },
  ] as any,
};

const LinearGauge = ({ title, value }: Props) => {
  const { isDarkMode } = useAppContext();
  const [chartOptions, setChartOptions] = useState(chart);
  const chartComponent = useRef(null);

  useEffect(() => {
    if (value) {
      prepareHighcharts(prepareData());
    }
  }, [value]);

  const prepareData = () => {
    return [
      {
        type: 'lineargauge',
        data: [Math.round(value * 10000) / 100],
        color: '#000000',
        dataLabels: {
          enabled: true,
          align: 'center',
          format: '{point.y}%',
        },
      },
    ];
  };

  const prepareHighcharts = (highChartsData) => {
    const c = {
      // title: {
      //   text: '',
      // },
      series: highChartsData,
    };
    setChartOptions(c);
  };

  return (
    <>
      <Box sx={{ /*display: 'flex',*/ justifyContent: 'center', pl: 1, pr: 1 }}>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography variant="h5" color="text.primary" sx={{ mt: 0 }}>
            {title}
          </Typography>
          <ChartHelpTooltip chartType="globalIndexRatio" />
        </Box>
        <HighchartsReact
          ref={chartComponent}
          containerProps={{ className: isDarkMode ? 'dark-chart' : '', style: { width: '100%' } }}
          highcharts={Highcharts}
          options={chartOptions}
        />
      </Box>
    </>
  );
};

export default LinearGauge;
